import { useState, useEffect } from "react";
import { forIn } from "lodash/object";
import clsx from "clsx";
import {
  HeadingOne,
  HeadingTwo,
  Paragraph,
  Image,
  ImageLeft,
  ImageRight,
} from "./PrintItems";

function PrintHeader({ header, agendaFont }) {
  const [one, setOne] = useState([]);
  const [two, setTwo] = useState([]);
  const [three, setThree] = useState([]);

  useEffect(() => {
    if (header) {
      const parsed = JSON.parse(header);
      forIn(parsed, (value, key) => {
        switch (key) {
          case "one":
            setOne(value);
            break;
          case "two":
            setTwo(value);
            break;
          case "three":
            setThree(value);
            break;

          default:
            console.log("should never see this");
            break;
        }
      });
    }
  }, [header]);

  return (
    <div className="pt-0 bg-white">
      <div className="grid grid-cols-10 h-full">
        <div
          className={clsx(
            "h-full p-1 flex flex-col justify-end col-span-3",
            agendaFont === "arial" && "font-arial",
            agendaFont === "sans-serif" && "font-sans",
            agendaFont === "timesNewRoman" && "font-timesNewRoman",
            agendaFont === "noto" && "font-noto"
          )}
        >
          {one.map((item, index) => {
            switch (item.type) {
              case "h1":
                return <HeadingOne key={index + 100}>{item.text}</HeadingOne>;
              case "h2":
                return <HeadingTwo key={index + 100}>{item.text}</HeadingTwo>;
              case "p":
                return <Paragraph key={index + 100}>{item.text}</Paragraph>;
              case "img":
                return <ImageLeft key={index + 100} src={item.text} alt="" />;
              default:
                return <div></div>;
            }
          })}
        </div>
        <div
          className={clsx(
            "h-full col-span-4 p-1 flex flex-col items-center justify-end",
            agendaFont === "arial" && "font-arial",
            agendaFont === "sans-serif" && "font-sans",
            agendaFont === "timesNewRoman" && "font-timesNewRoman",
            agendaFont === "noto" && "font-noto"
          )}
        >
          {two.map((item, index) => {
            switch (item.type) {
              case "h1":
                return <HeadingOne key={index + 100}>{item.text}</HeadingOne>;
              case "h2":
                return <HeadingTwo key={index + 100}>{item.text}</HeadingTwo>;
              case "p":
                return <Paragraph key={index + 100}>{item.text}</Paragraph>;
              case "img":
                return <Image key={index + 100} src={item.text} alt="" />;
              default:
                return <div></div>;
            }
          })}
        </div>
        <div
          className={clsx(
            "h-full p-1 flex flex-col items-end justify-end col-span-3",
            agendaFont === "arial" && "font-arial",
            agendaFont === "sans-serif" && "font-sans",
            agendaFont === "timesNewRoman" && "font-timesNewRoman",
            agendaFont === "noto" && "font-noto"
          )}
        >
          {three.map((item, index) => {
            switch (item.type) {
              case "h1":
                return <HeadingOne key={index + 100}>{item.text}</HeadingOne>;
              case "h2":
                return <HeadingTwo key={index + 100}>{item.text}</HeadingTwo>;
              case "p":
                return <Paragraph key={index + 100}>{item.text}</Paragraph>;
              case "img":
                return <ImageRight key={index + 100} src={item.text} alt="" />;
              default:
                return <div></div>;
            }
          })}
        </div>
      </div>
    </div>
  );
}

export default PrintHeader;
